import { NumberFormatter } from 'reduce-precision';

const usdFormatter = new NumberFormatter({template:'usd', language:'en', precision:'auto'});
const irtFormatter = new NumberFormatter({template:'irt', language:'fa', precision:'medium'});
const escape = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

// Keep identical value hierarchy in single- and multi-select pickers.
export function pickerPrices(asset) {
  const usd = escape(usdFormatter.toString(Number(asset.usd)));
  const parts = irtFormatter.toJson(Number(asset.toman));
  const irt = `<span class="arz-converter-irt-price"><span>${escape(parts.sign + parts.wholeNumber)}</span><span>${escape(parts.postfix.trim())}</span></span>`;
  const irtFirst = asset.type === 'fiat' || asset.type === 'commodity';
  return `<span class="arz-converter-asset-option__prices" dir="ltr"><strong>${irtFirst ? irt : usd}</strong><span>${irtFirst ? usd : irt}</span></span>`;
}
